import countries, { facebookAdCountriesByName, facebookAdCountriesByISO2 } from '@constants/facebookAdCountries';

(function() {
  const curalate = angular.module('curalate');

  curalate.constant('Countries', countries);
  curalate.constant('CountriesByName', facebookAdCountriesByName);
  curalate.constant('CountriesByISO2', facebookAdCountriesByISO2);
})();

